import React from 'react';

interface RowProps {
    space?: boolean;
    padding?: boolean;
    children?: React.ReactNode;
    style?: Object;
}

export default function Row({ space, children, style, padding }: RowProps) {

    return (
        <div style={{ padding: padding ? 12 : 0, display: "flex", flexDirection: "row", justifyContent: space ? "space-between" : "flex-start", alignItems: 'center' ,width: "100%", ...style }}>
            {children}
        </div>
    );
}